
import { Component, Ref, Prop, Watch, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonStrongSquare from '@/components/molecules/ButtonStrongSquare.vue'
import DrawingArea from '@/components/molecules/DrawingArea.vue'
import DrawStroke from '@/components/molecules/DrawStroke.vue'
import TogglePenControl from '@/components/organisms/study/TogglePenControl.vue'
import { PenSetting } from '@/const/PenSetting'
import { DrawingModel } from '@/models/DrawingModel'

/**
 * 演習メモエリア
 */
@Component({
  components: {
    ImageBase,
    ButtonStrongSquare,
    DrawingArea,
    DrawStroke,
    TogglePenControl,
  },
})
export default class MemoArea extends Vue {
  /** 手書きエリア */
  @Ref()
  drawingArea!: DrawingArea

  /** ペン選択 */
  @Ref()
  togglePenControl!: TogglePenControl

  /** エリアの表示状態 */
  @Prop()
  isShown!: boolean

  /** メモの編集可否 */
  @Prop({ default: true })
  isEditable!: boolean

  /** 表示専用モード時のストローク情報 */
  @Prop({ default: () => [] })
  savedStrokes!: DrawingModel.Stroke[]

  /** ペン情報 */
  private activePen = PenSetting.PEN_BLACK

  /** ストローク情報 */
  public strokes: DrawingModel.Stroke[] = []

  /**
   * 表示状態の監視
   */
  @Watch('isShown')
  private updateShownStatus(): void {
    // 表示された時にペン情報をリセットする
    if (this.isShown) {
      this.activePen = PenSetting.PEN_BLACK
    }
  }

  /**
   * ペンの切り替え
   *
   * @param activePen アクティブなペン
   */
  private togglePen(activePen: DrawingModel.PenAsset): void {
    this.activePen = activePen
  }

  /**
   * ストロークの消去
   */
  private clearStrokes(): void {
    this.strokes.splice(0)
    // キャンバスの再描画
    this.drawingArea.drawAllStrokes()
  }

  /**
   * 閉じるボタン押下時のイベント発火
   */
  private hide(): void {
    this.$emit('hide')
  }
}
